export const de = {
  nav: {
    home: 'HOME',
    about: 'ÜBER MICH',
    services: 'LEISTUNGEN',
    approach: 'ANSATZ',
    insights: 'IMPULSE',
    testimonials: 'STIMMEN',
    contact: 'KONTAKT',
    cta: 'Vorgespräch anfragen',
    menu: 'Menu',
    close: 'Schließen',
  },
  footer: {
    aboutHeading: 'Über Prof.in Michaela Braun',
    about:
      'Prof.in Michaela Braun ist Rechtsanwältin, zertifizierte Wirtschaftsmediatorin, zertifizierte systemisch integrative Business Coachin und zertifizierte Process Communication® Coachin. Sie ist tätig in ihrer Kanzlei in München sowie als Professorin an der Hochschule der Bayerischen Wirtschaft und Dozentin an diversen anderen Hochschulen und Universitäten.',
    copyrightName: 'Prof.in Michaela Braun',
    insights: 'Impulse',
    speaking: 'Vorträge',
    privacy: 'Datenschutz',
    legal: 'Impressum',
    cookies: 'Cookie-Einstellungen',
    contactTitle: 'Kontakt',
    contactSubtitle:
      'Schildern Sie kurz Ihr Anliegen. Im Vorgespräch klären wir, ob und in welchem Raum ich Sie sinnvoll begleiten kann.',
    namePlaceholder: 'Ihr Name',
    emailPlaceholder: 'Ihre E-Mail',
    messagePlaceholder: 'Ihre Nachricht',
    send: 'Nachricht senden',
    logoAlt: 'Michaela Braun Logo',
    mailSubject: (name) => `Kontaktanfrage von ${name}`,
  },
  cookie: {
    title: 'Ihre Privatsphäre',
    before:
      'Mit Ihrer Einwilligung nutze ich Google Analytics, um die Nutzung dieser Website pseudonym auszuwerten. Dabei werden Cookies gesetzt und Daten gegebenenfalls in die USA übermittelt. Sie können Ihre Entscheidung jederzeit über „Cookie-Einstellungen“ im Fußbereich ändern. Weitere Informationen finden Sie in der',
    link: 'Datenschutzerklärung',
    after: '.',
    decline: 'Ablehnen',
    accept: 'Akzeptieren',
  },
  modal: {
    title: 'Vorgespräch anfragen',
    subtitle: 'Bitte füllen Sie das Formular aus. Ich melde mich schnellstmöglich bei Ihnen.',
    name: 'Name *',
    namePlaceholder: 'Ihr Name',
    phone: 'Telefonnummer *',
    phonePlaceholder: 'Ihre Telefonnummer',
    email: 'E-Mail-Adresse *',
    emailPlaceholder: 'Ihre E-Mail-Adresse',
    website: 'Website',
    sending: 'Wird gesendet...',
    send: 'Anfrage senden',
    success: 'Vielen Dank! Ihre Anfrage wurde erfolgreich gesendet. Ich melde mich bald bei Ihnen.',
    error:
      'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie mich direkt per E-Mail.',
    privacyBefore:
      'Mit dem Absenden werden Ihre Angaben an mich übermittelt, um Ihre Terminanfrage zu bearbeiten. Weitere Informationen finden Sie in der',
    privacyLink: 'Datenschutzerklärung',
    privacyAfter: '.',
    close: 'Schließen',
  },
  home: {
    heroAria: 'Einstieg',
    eyebrow: 'COACHING · MEDIATION · EXECUTIVE BEGLEITUNG',
    title: 'Veränderung verlangt Wahrheit.',
    sub: 'Hier wird sie sichtbar.',
    audience:
      'Für Unternehmerinnen, Unternehmer und Führungskräfte, wenn eine Verhandlung, ein Konflikt oder eine Nachfolge zu groß für Routine ist.',
    cta: 'Vorgespräch anfragen',
    roomsLink: 'Die drei Räume ansehen',
    roomsAria: 'Die drei Spiegel-Räume',
    roomsHeading: 'Die drei Räume',
    roomsIntro:
      'Rechtsanwältin, Mediatorin und Coachin in einer Person: Sie sehen nicht nur die menschliche Dynamik, sondern auch, was rechtlich und wirtschaftlich auf dem Spiel steht.',
    formatLabel: 'Format:',
    profileAria: 'Profil',
    profileHeading: 'Profil',
    profile:
      'Rechtsanwältin, Mediatorin, Coachin und Honorarprofessorin — mit über 25 Jahren Erfahrung in der Begleitung von Unternehmer:innen, Nachfolger:innen und Führungskräften.',
    closingAria: 'Abschluss',
    closing: 'Wenn Veränderung ansteht, beginnt Klarheit mit einem Gespräch.',
    logoAlt: 'Michaela Braun',
  },
  about: {
    label: 'ÜBER MICHAELA BRAUN',
    p1: 'Ich begleite Unternehmerinnen, Unternehmer und Führungskräfte in Momenten, in denen viel auf dem Spiel steht: in entscheidenden Verhandlungen, in festgefahrenen Konflikten und bei Übergängen in Familienunternehmen.',
    p2: 'Nach Studien an der LMU München, der Universität Wien und einer Tätigkeit an der Tulane University (USA) bin ich seit 1992 als Rechtsanwältin zugelassen und seit 2013 in der Lehre tätig, heute als Honorarprofessorin für Wirtschaftsrecht und Entrepreneurship an der HDBW München sowie als Lehrbeauftragte für den Schwerpunkt „Family Owned Businesses" an der Zeppelin Universität und der Munich Business School.',
    p3: 'Meine Erfahrung aus unzähligen Mandaten im Wirtschafts-, Vertrags- und Familienrecht ergänze ich durch Qualifikationen als jeweils zertifizierte Wirtschaftsmediatorin, systemisch-integrative Business Coachin und PCM-Coachin.',
    p4: 'So ist es mir möglich, fundierte juristische Kompetenz mit tiefem Verständnis für menschliche Dynamiken, emotionale Prozesse und wirksame Kommunikation zu verbinden.',
    link: 'Impulse & Perspektiven →',
    photoAlt: 'Prof.in Michaela Braun',
    crumb: 'Über mich',
  },
  services: {
    label: 'Leistungen',
    title: '1:1 Spiegel-Arbeit, Spiegelkraft für Systeme, Spiegel für Wirkung und Haltung',
    intro:
      'Drei Räume für Momente, in denen viel auf dem Spiel steht. Sie wählen nach Ihrer Situation, nicht nach der Methode.',
    talks: 'Vorträge für Ihre Veranstaltung',
    crumb: 'Leistungen',
    alts: ['1:1 Spiegel-Arbeit', 'Spiegelkraft für Systeme', 'Spiegel für Wirkung und Haltung'],
  },
  contact: {
    label: 'KONTAKT',
    title: 'Nehmen Sie Kontakt auf',
    intro:
      'Schildern Sie kurz Ihr Anliegen. Im Vorgespräch klären wir, ob und in welchem Raum ich Sie sinnvoll begleiten kann.',
    email: 'E-Mail',
    office: 'Telefon (Büro)',
    mobile: 'Telefon (Mobil)',
    ask: 'Möchten Sie ein persönliches Gespräch vereinbaren?',
    cta: 'Vorgespräch anfragen',
    crumb: 'Kontakt',
  },
  speaking: {
    label: 'Vortragstätigkeit',
    title: 'Fachliche Klarheit. Menschliche Wirkung.',
    p1: 'In meinen Vorträgen verbinde ich rechtliche Expertise, langjährige Beratungserfahrung und moderne Methoden der Kommunikations- und Führungspraxis.',
    p2: 'Ich spreche zu den Themen Kommunikation, schwierige Gespräche, Verhandlungstechnik und Führung – stets mit dem Ziel, komplexe Inhalte verständlich zu machen und praktische Impulse zu geben, die im beruflichen Alltag unmittelbar weiterhelfen.',
    caption: 'Vortrag beim Bayerischen Notarverein',
    cta: 'Für Ihre Veranstaltung anfragen',
    alt: 'Vortragstätigkeit',
    crumb: 'Vorträge',
  },
  testimonials: {
    title: 'Stimmen',
    note: '',
    aria: 'Stimmen',
    crumb: 'Stimmen',
  },
  insights: {
    label: 'Impulse',
    title: 'Perspektiven',
    intro: 'Fachbeiträge zu Reflexion, Führung und struktureller Veränderung – in unregelmäßigen Abständen.',
    empty: 'Der erste Beitrag folgt in Kürze.',
    back: 'Mehr über Michaela Braun →',
    crumb: 'Impulse',
  },
  legal: {
    back: '← Zurück zur Startseite',
    title: 'Impressum',
    note: '',
    crumb: 'Impressum',
  },
  privacyPage: {
    back: '← Zurück zur Startseite',
    note: '',
    crumb: 'Datenschutz',
  },
  seo: {
    home: {
      title: 'Prof.in Michaela Braun | Veränderung verlangt Wahrheit',
      description:
        'Für Unternehmerinnen, Unternehmer und Führungskräfte in Verhandlungen, Konflikten und Nachfolge. Rechtsanwältin, Mediatorin und Coachin in München.',
    },
    about: {
      title: 'Über mich | Prof.in Michaela Braun',
      description:
        'Rechtsanwältin, Mediatorin und Honorarprofessorin in München. Begleitung in Verhandlungen, Konflikten und Familienunternehmen.',
    },
    services: {
      title: 'Drei Räume der Spiegel-Arbeit | Michaela Braun',
      description:
        '1:1 Spiegel-Arbeit, Spiegelkraft für Systeme und Spiegel für Wirkung und Haltung. Für Verhandlungen, Konflikte und Top-Management.',
    },
    testimonials: {
      title: 'Stimmen | Coaching, Mediation, Workshops',
      description:
        'Rückmeldungen aus Geschäftsführung, Führungskreis und Beratung zu Coaching, Mediation und Workshops mit Prof.in Michaela Braun.',
    },
    insights: {
      title: 'Impulse zu Wirkung und Führung | Michaela Braun',
      description:
        'Fachbeiträge von Prof.in Michaela Braun: das Bild, das andere von Ihnen haben, und warum Machtspiele Frauen ausbremsen.',
    },
    speaking: {
      title: 'Vorträge zu Führung und Verhandlung | Michaela Braun',
      description:
        'Vorträge zu Kommunikation, schwierigen Gesprächen, Verhandlungstechnik und Führung. Prof.in Michaela Braun, München.',
    },
    contact: {
      title: 'Kontakt | Vorgespräch mit Michaela Braun',
      description:
        'Schildern Sie kurz Ihr Anliegen. Im Vorgespräch klären wir, ob Spiegel-Arbeit, Systembegleitung oder ein Vortrag passt.',
    },
    legal: {
      title: 'Impressum – Michaela Braun',
      description: 'Impressum und Anbieterkennzeichnung von michaelabraun.de.',
    },
    privacy: {
      title: 'Datenschutzhinweise – Michaela Braun',
      description:
        'Datenschutzhinweise für Klientinnen und Klienten zu Coaching, Mediation und Workshops.',
    },
  },
};
